import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Header from "./components/Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/circle.css';
import './assets/css/font-awesome.min.css';
import './assets/css/style.css';
import './assets/css/skins/yellow.css';
import SimpleReactLightbox from "simple-react-lightbox";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { AnimatedSwitch } from 'react-router-transition';
import React from "react";
function App() {
  return (
      <>
          <Router>
              <Header />
              <AnimatedSwitch
                  atEnter={{ opacity: 0 }}
                  atLeave={{ opacity: 0 }}
                  atActive={{ opacity: 1 }}
                  className="switch-wrapper"
              >
                  <Route exact path='/' component={Home} />
                  <Route path='/about' component={About} />
                  <Route path='/contact' component={Contact} />
                  <Route path='/blog' component={Blog} />
                  <Route path='/blogpost' component={BlogPost} />
                  <SimpleReactLightbox>
                      <Route path='/portfolio' component={Portfolio} />
                  </SimpleReactLightbox>
              </AnimatedSwitch>
          </Router>
      </>
  );
}

export default App;
